import React, { useContext, useState } from 'react';

import { RestApiContext } from '../../../contexts/RestApiContext';
import { useAggregatedState, useBusyState } from '../../../../helpers';

export const PageContext = React.createContext(null);

const { Provider } = PageContext;
export const PageProvider = ({ ...props }) => {
    const [pageIsReady, setPageIsReady] = useState(false);
    const [busy, isBusy, setIsBusy] = useBusyState({});
    const [state, setState] = useAggregatedState({
        role: null
    });

    const apiClient = useContext(RestApiContext);

    const getRoleAsync = async (roleId) => {
        try {
            const role = await apiClient.getRoleAsync(roleId, true);
            setState({ role });
        } catch (e) {
            console.debug(e);
        }
    }

    return (
        <Provider value={{
            state,
            pageIsReady,
            setPageIsReady,
            isBusy,
            setIsBusy,
            getRoleAsync,
        }}>
            {props.children}
        </Provider>
    );
}